import React from "react";
import LocationCard from "./LocationCard.js";
import { popularLocations } from "../../data/mockLocations.js";

interface PopularLocationsProps {
  className?: string;
}

const PopularLocations: React.FC<PopularLocationsProps> = ({ className }) => {
  return (
    <div className={`flex-1 ${className || ""}`}>
      <h2 className="mb-2 text-sm font-semibold text-nearblack-500">
        Des emplacements populaires
      </h2>
      <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap">
        {popularLocations.map((location) => (
          <LocationCard
            key={location.id}
            location={location}
            className="w-full sm:min-w-[200px] sm:flex-1"
          />
        ))}
      </div>
    </div>
  );
};

export default PopularLocations;
